import { render } from "./InvoiceProcessor.vue?vue&type=template&id=243e64dc&scoped=true"
import script from "./InvoiceProcessor.vue?vue&type=script&lang=js"
export * from "./InvoiceProcessor.vue?vue&type=script&lang=js"

import "./InvoiceProcessor.vue?vue&type=style&index=0&id=243e64dc&lang=css"
import "./InvoiceProcessor.vue?vue&type=style&index=1&id=243e64dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243e64dc"]])

export default __exports__